import { render, staticRenderFns } from "./CheckboxFieldResponse.vue?vue&type=template&id=478411f5&scoped=true"
import script from "./CheckboxFieldResponse.vue?vue&type=script&lang=js"
export * from "./CheckboxFieldResponse.vue?vue&type=script&lang=js"
import style0 from "./CheckboxFieldResponse.vue?vue&type=style&index=0&id=478411f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478411f5",
  null
  
)

export default component.exports